import { isPendingBankPayment, useGetPaymentMethods } from '~/domain/Payments';
import { useIsParentOfficeSelector } from '~/hooks/useIsParentOfficeSelector';

export const usePendingAchBannerVisible = () => {
  const { paymentMethods } = useGetPaymentMethods();
  const isParentOffice = useIsParentOfficeSelector();
  return !isParentOffice && paymentMethods.some(isPendingBankPayment);
};
